import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Heading,
  
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Input,
  Box,
} from "@chakra-ui/react";

import AdminLogin from "../AdminNav/Login";
import { MyContext } from "../../MyProvider";

import { PageHeader } from "../../components/ui";

function Occupation() {
  const {userData,eventData,horoData}=useContext(MyContext);
  const [occupation, setOccupation] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
        setOccupation([...userData.filter((oc) => oc.occupation),...eventData.filter((oc) => oc.occupation),...horoData.filter((oc) => oc.occupation)]);
      
  }, [userData,eventData,horoData]);

  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredOccupations = occupation.filter((person) =>
    person.occupation.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <PageHeader title="Occupations" subtitle={`${occupation.length} recorded`}>
        <Input
          placeholder="Search by occupation"
          aria-label="Search by occupation"
          type="search"
          value={searchTerm}
          onChange={handleSearchChange}
          w={{ base: "100%", md: "280px" }}
        />
      </PageHeader>
      <TableContainer borderRadius="lg" border="1px solid" borderColor="stone.200">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Full Name</Th>
              <Th>Occupation</Th>
              <Th>Contact</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredOccupations.map((person, index) => (
              <Tr key={index}>
                <Td>{person.fname + " " + person.lname}</Td>
                <Td>{person.occupation}</Td>
                <Td>{person.phone}</Td>
                <Td>
                  <Link to={`/admin/usersDtails/${person.userId||person._id}`}>
                    <Button variant="outline" size="sm"
                    >
                      View User
                    </Button>
                  </Link>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
}

export default Occupation;
